module.exports = __webpack_public_path__ + "static/media/guru-prasadam.a89adc60.png";